var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtworkProductImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 35,
    viewBox: "0 0 39 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4545 0H3.54545C2.60514 0 1.70334 0.368749 1.03844 1.02513C0.373538 1.6815 0 2.57174 0 3.5V24.5C0 25.4283 0.373538 26.3185 1.03844 26.9749C1.70334 27.6313 2.60514 28 3.54545 28H15.9545V31.5H12.4091V35H26.5909V31.5H23.0455V28H35.4545C36.3949 28 37.2967 27.6313 37.9616 26.9749C38.6265 26.3185 39 25.4283 39 24.5V3.5C39 2.57174 38.6265 1.6815 37.9616 1.02513C37.2967 0.368749 36.3949 0 35.4545 0ZM35.4545 24.5H3.54545V3.5H35.4545V24.5Z",
    fill: "url(#paint0_linear_564_25965)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7328 9.6641V19.4236L19.9328 23.0994L12.1328 19.4236V9.6641L19.9328 5.98828L27.7328 9.6641ZM19.9328 7.81978L14.9359 10.1764L19.9328 12.533L24.9297 10.1764L19.9328 7.81978ZM13.8661 18.4118L19.0661 20.858V13.9547L13.8661 11.4956V18.4118ZM25.9995 18.4118V11.4956L20.7995 13.9547V20.858L25.9995 18.4118Z",
    fill: "url(#paint1_linear_564_25965)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_564_25965",
    x1: 19.5,
    y1: 0,
    x2: 19.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_564_25965",
    x1: 19.9328,
    y1: 5.98828,
    x2: 19.9328,
    y2: 23.0994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtworkProductImg);
export default __webpack_public_path__ + "static/media/Artwork_product_img.b26fc21246d95f1d2b59271251984e24.svg";
export { ForwardRef as ReactComponent };